<div
  class="d-flex w-100 gap-2 align-items-center"
  [id]="message.id"
  [ngClass]="{ 'flex-row-reverse': message.created_by }"
  [cdkContextMenuTriggerFor]="menu"
  (mouseup)="onTextSelect()"
  (contextmenu)="onContextMenuOpen()"
>
  <!--  (click)="baseService.isMobile ? openContextMenu($event) : null"-->

  @if (isPinned) {
    <app-button (onChangeClick)="goToMessage()" btnType="icon">
      <app-icon class="icon-white">arrow_forward</app-icon>
    </app-button>
  }

  <div class="message-wrapper" [ngStyle]="{ '--profile-color': $safeNavigationMigration(sender?.color) }">
    <!-- Avatar -->
    @if (chatService.chat.sub_type === CHAT_SUB_TYPES.GROUP && !message.created_by) {
      <app-avatar
        class="message-profile-photo"
        size="35px"
        [title]="$safeNavigationMigration(sender?.name)"
        [mediaId]="$safeNavigationMigration(sender?.photo_id)"
        [chatId]="chatService.chat.id"
        [url]="$safeNavigationMigration(sender?.url)"
      />
    }

    <div class="message" [ngClass]="messageClasses">
      <div class="message-content">
        <!-- Message Header -->
        <ng-container *ngTemplateOutlet="messageHeaderTemplate; context: { sub_type: chatService.chat.sub_type }" />

        <!-- Unsupported message -->
        @if (unsupportedMessage) {
          <span class="frame-message">
            {{ 'message_type_not_supported' | translate }}
          </span>
        }

        <!-- AI generating -->
        @if (message.type_message === MESSAGE_TYPES.TEXT_AI) {
          <div class="frame-message">
            {{ 'ai_generate' | translate }}
          </div>
        }

        <!-- Media -->
        @if (media && media.length && !isSharedPost && !productData) {
          <ng-container *ngTemplateOutlet="gallery; context: { gallery_items: media }" />
        }

        <!-- Inst ad comments (post is null, text is in x_data.value.text) -->
        @if (message.type_message === MESSAGE_TYPES.TEXT_COMMENT && !commentedPostData && message.x_data?.value?.text) {
          <span>{{ message.text }}</span>
        }

        <!-- Inst comments on post -->
        @if (commentedPostData) {
          <div class="commented-post-preview flex flex-col gap-2">
            <div
              class="rounded-md border-l-4 border-white/35 bg-black/15 px-3 py-2 text-[15px] font-semibold leading-snug text-white/95"
            >
              <span>{{ 'add_comment_to_your_post_prefix' | translate }}</span>
              <a
                [href]="commentedPostData.post_url"
                target="_blank"
                rel="noopener noreferrer"
                class="ml-1 inline-flex items-center gap-1 !text-sky-300 !no-underline transition hover:!text-sky-200"
              >
                <span class="underline decoration-sky-300/70 underline-offset-2">{{
                  'comment_post_link_label' | translate
                }}</span>
                <app-icon class="!h-4 !w-4 !text-[16px] !leading-none">open_in_new</app-icon>
              </a>
            </div>
            @if (hasRenderableAttachments(commentedPostData.attachments)) {
              <ng-container *ngTemplateOutlet="gallery; context: { gallery_items: commentedPostData.attachments }">
              </ng-container>
            }
            @if (commentedPostData.comment) {
              <div>
                <span>
                  {{ commentedPostData.comment }}
                </span>
              </div>
            }
          </div>
        }

        <!-- Shared the post -->
        @if (isSharedPost && sharedPost) {
          <div class="flex flex-col gap-2">
            @if (sharedPost.postUrl !== 'UNKNOWN') {
              <div
                class="rounded-md border-l-4 border-white/35 bg-black/15 px-3 py-2 text-[15px] font-semibold leading-snug text-white/95"
              >
                <span>{{ 'shared_post_prefix' | translate }}</span>
                <a
                  [href]="sharedPost.postUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="ml-1 inline-flex items-center gap-1 !text-sky-300 !no-underline transition hover:!text-sky-200"
                >
                  <span class="underline decoration-sky-300/70 underline-offset-2">{{
                    'shared_post_link_label' | translate
                  }}</span>
                  <app-icon class="!h-4 !w-4 !text-[16px] !leading-none">open_in_new</app-icon>
                </a>
              </div>
            }

            @if (sharedPost.postUrl === 'UNKNOWN') {
              <div
                class="rounded-md border-l-4 border-white/35 bg-black/15 px-3 py-2 text-[15px] font-semibold leading-snug text-white/95"
              >
                <span>{{ 'shared_post' | translate }}</span>
              </div>
            }

            @if (hasRenderableAttachments(sharedPostItems)) {
              <ng-container *ngTemplateOutlet="gallery; context: { gallery_items: sharedPostItems }"> </ng-container>
            }

            @if (sharedPost.caption) {
              <div>
                <span>
                  {{ sharedPost.caption }}
                </span>
              </div>
            }
          </div>
        }

        @if (productData && media) {
          <div class="d-flex flex-column">
            <div>
              <strong>{{ 'product' | translate }}: </strong>
              @if (productData.product_public_url) {
                <a href="{{ productData.product_public_url }}" target="_blank">
                  <span>{{ productData.name }}</span>
                </a>
              } @else {
                <span>{{ productData.name }}</span>
              }
            </div>

            <ng-container *ngTemplateOutlet="gallery; context: { gallery_items: media }"> </ng-container>

            @if (productData.description) {
              <span
                ><strong>{{ 'description' | translate }}</strong
                >: {{ productData.description }}</span
              >
              <br />
            }

            @if (productData.price) {
              <span
                ><strong>{{ 'price' | translate }}</strong
                >: {{ productData.price }} {{ productData.currency }}</span
              >
              @if (productData.minimum_order_quantity) {
                <span
                  ><strong>{{ 'minimum_order_quantity' | translate }}</strong
                  >: {{ productData.minimum_order_quantity }}</span
                >
              }
            }

            @if (productData.prices.length) {
              <br />
              <strong>{{ 'retail_prices' | translate }}:</strong>
              @for (price of productData.prices; track price) {
                <span
                  ><strong>{{ 'price' | translate }}</strong
                  >: {{ productData.price }} {{ productData.currency }}</span
                >
                <span
                  ><strong>{{ 'minimum_order_quantity' | translate }}</strong
                  >: {{ price.minimum_order_quantity }}</span
                >
              }
            }
          </div>
        }

        <!-- Files -->
        <ng-container *ngTemplateOutlet="filesTemplate" />

        <!-- Audio -->
        <ng-container *ngTemplateOutlet="audioTemplate" />

        <!-- Round -->
        @if (round) {
          <app-round
            [url]="round.shown_url"
            [duration]="round.duration"
            [isLoading]="round.loading"
            (onLoadRound)="initMediaShownUrl(round)"
          />
        }

        <!-- Sticker -->
        <ng-container *ngTemplateOutlet="stickerTemplate" />

        <!-- Text -->
        <ng-container *ngTemplateOutlet="textTemplate" />

        <!-- Transcription / Translation -->
        <ng-container *ngTemplateOutlet="messageAiTemplate" />

        <!-- Ria Auction -->
        <ng-container *ngTemplateOutlet="riaAuctionTemplate" />

        <!-- Ria Trade -->
        <ng-container *ngTemplateOutlet="riaTradeTemplate" />

        <!-- Status -->
        <ng-container *ngTemplateOutlet="statusTemplate" />
      </div>

      <!-- Logs -->
      <ng-container *ngTemplateOutlet="logsTemplate" />

      <!-- Reactions -->
      <ng-container *ngTemplateOutlet="reactionsTemplate" />

      <ng-container *ngTemplateOutlet="showMessageActionsTemplate" />
    </div>
  </div>

  @if (showChangeReaction()) {
    <app-button btnType="icon" [cdkMenuTriggerFor]="changeReactionTemplate" (click)="$event.stopPropagation()">
      <app-icon class="icon-white">add_reaction</app-icon>
    </app-button>
  }

  @if (baseService.isMobile) {
    <app-button [cdkMenuTriggerFor]="menu" (click)="onContextMenuOpen(); $event.stopPropagation()" btnType="icon">
      <app-icon class="icon-white">more_vert</app-icon>
    </app-button>
  }
</div>

<ng-template #menu>
  <div class="chat-message-context-menu" cdkMenu>
    @for (item of menus; track $index) {
      <button (click)="item.action($event)" class="context-menu-item clear-line" cdkMenuItem>
        @if (item.is_svg) {
          <app-icon [svgIcon]="item.icon" />
        } @else {
          <app-icon>{{ item.icon }}</app-icon>
        }
        <span>{{ item.title | translate }}</span>
      </button>
    }
  </div>
</ng-template>

<ng-template #download let-item="item">
  <div class="chat-message-context-menu" cdkMenu>
    <button (click)="onDownloadAttachment(item)" class="context-menu-item clear-line" cdkMenuItem>
      <app-icon>download</app-icon>
      <span>{{ 'download' | translate }}</span>
    </button>
  </div>
</ng-template>

<ng-template #gallery let-galleryItems="gallery_items">
  <div
    [ngClass]="getGridClass(galleryItems)"
    [appPhotoGalleryGroup]="{ clickMode: 'single' }"
    class="message-media-content"
  >
    @for (item of galleryItems; track $index) {
      @if (item.shown_url || item.url || item.id) {
        <div
          [cdkContextMenuTriggerFor]="download"
          [cdkContextMenuTriggerData]="{ item }"
          class="message-media-container"
        >
          @if (!item.error) {
            @if (!item.shown_url) {
              <div
                class="message-media-action"
                [ngClass]="{ 'click-css': !item.loading }"
                (click)="initMediaShownUrl(item)"
                matTooltip="
                    {{ 'attachments.' + attachmentsTooltipMap[item.video_gif ? 'gif' : item.type] | translate }},
                    {{ 'file_size' | translate }}: {{ item.size ? (item.size | fileSize) : '??? B' }}
                   "
              >
                @if (!item.loading) {
                  <app-icon class="icon-lg">download</app-icon>
                } @else {
                  <app-loader color="pi-white" size="smaller" />
                }
              </div>
            }
            @if (item.shown_url) {
              @switch (item.type) {
                @case (ATTACHMENTS_TYPES.IMAGE) {
                  <img
                    class="chat-image click-css"
                    [alt]="'Media'"
                    loading="lazy"
                    [src]="item.shown_url"
                    [appPhotoGallery]="{
                      mimeType: item.mime_type || item.mimeType || 'image/png',
                      url: item.shown_url,
                    }"
                    (error)="loadError(item)"
                  />
                }
                @case (ATTACHMENTS_TYPES.VIDEO) {
                  <video
                    class="chat-image"
                    [src]="item.shown_url"
                    playsinline
                    preload="metadata"
                    [controls]="!item.video_gif"
                    [autoplay]="item.video_gif"
                    [loop]="item.video_gif"
                    [muted]="item.video_gif"
                  >
                    <source [src]="item.shown_url" [type]="item.mime_type || item.mimeType || 'video/mp4'" />
                    Your browser does not support the video tag.
                  </video>
                }
              }
            }
          } @else {
            @if (RELOAD_MEDIA_TYPE_CHATS.includes(this.chatService.chat.external_type)) {
              <div
                id="bad-image"
                class="message-media-action"
                [ngClass]="{ 'click-css': !item.loading }"
                (click)="reloadImages(item)"
              >
                @if (!item.loading) {
                  <app-icon class="icon-lg">refresh</app-icon>
                } @else {
                  <app-loader color="pi-white" size="smaller" />
                }
              </div>
            } @else if (!item.loading) {
              <div class="message-media-action" [matTooltip]="'download_error' | translate">
                <app-icon class="icon-lg">sentiment_dissatisfied</app-icon>
              </div>
            }
          }
        </div>
      }
    }
  </div>
</ng-template>

<ng-template #messageHeaderTemplate let-sub_type="sub_type">
  @if ((sub_type === CHAT_SUB_TYPES.GROUP && !message.created_by && sender?.name) || forwardedFrom || replyTo) {
    <div class="message-message-header">
      <!-- Sender Name -->
      <ng-container *ngTemplateOutlet="senderNameTemplate; context: { sub_type }" />

      <!-- Forwarded From -->
      <ng-container *ngTemplateOutlet="forwardedFromTemplate" />

      <!-- Reply To -->
      <ng-container *ngTemplateOutlet="replyToTemplate" />

      <!-- Reply To Story-->
      <ng-container *ngTemplateOutlet="replyToStoryTemplate" />
    </div>
  }
</ng-template>

<ng-template #senderNameTemplate let-sub_type="sub_type">
  @if (sub_type === CHAT_SUB_TYPES.GROUP && !message.created_by) {
    <div class="message-message-header-item message-sender-name">
      @if (sender?.name) {
        <span class="fw-500 text-truncate">{{ sender?.name }}</span>
      } @else {
        <span>{{ 'unknown_name' | translate }}</span>
      }
    </div>
  }
</ng-template>

<ng-template #forwardedFromTemplate>
  @if (forwardedFrom) {
    <div class="message-message-header-item message-forwarded-from text-truncate">
      <app-icon class="icon-sm" svgIcon="forward" />
      {{ 'forwarded_from' | translate }}
      <app-avatar
        size="16px"
        [title]="forwardedFrom.from_name"
        [mediaId]="forwardedFrom.from_photo_id"
        [chatId]="chatService.chat.id"
        [url]="forwardedFrom.from_photo_url"
        [isPhotoGallery]="false"
      />
      @if (forwardedFrom.from_name) {
        <span class="fw-500 text-truncate">{{ forwardedFrom.from_name }}</span>
      } @else {
        <span class="text-truncate">{{ 'unknown_name' | translate }}</span>
      }
    </div>
  }
</ng-template>

<ng-template #replyToTemplate>
  @if (replyTo && !replyTo.to_story_id) {
    <div
      class="message-message-header-item message-reply-to click-css text-truncate"
      (click)="goToReplyToMessage()"
      matRipple
    >
      <span class="message-reply-to-title">
        @if (replyTo.is_another_chat) {
          @if (replyTo.from_another_chat_type === CHAT_SUB_TYPES.PRIVATE && !replyTo.is_fwd) {
            <app-icon class="icon-xsm" svgIcon="person_fill" />
          }
          @if (replyTo.from_another_chat_type === CHAT_SUB_TYPES.CHANNEL) {
            <app-icon class="icon-xsm" svgIcon="campaign_fill" />
          }
        }

        @if (replyTo.to_name) {
          <span class="fw-500 text-truncate">{{ replyTo.to_name }}</span>
        } @else {
          <span class="text-truncate">{{ 'unknown_name' | translate }}</span>
        }

        @if (replyTo.is_another_chat && replyTo.from_another_chat_type === CHAT_SUB_TYPES.GROUP) {
          <app-icon class="icon-xsm" svgIcon="groups_fill" />
        }

        @if (replyTo.is_fwd) {
          <app-icon class="icon-xsm" svgIcon="forward" />
        }

        @if (replyTo.from_name) {
          <span class="fw-500 text-truncate">{{ replyTo.from_name }}</span>
        }
        @if (replyTo.from_another_chat_type === CHAT_SUB_TYPES.GROUP && !replyTo.from_name) {
          <span class="text-truncate">
            {{ 'unknown_group' | translate }}
          </span>
        }

        @if (replyTo.fwd_name) {
          <span class="fw-500 text-truncate">{{ replyTo.fwd_name }}</span>
        }
        @if (replyTo.is_fwd && !replyTo.fwd_name) {
          <span class="text-truncate">
            {{ 'unknown_name' | translate }}
          </span>
        }

        <div class="flex-fill"></div>

        @if (replyTo.is_quote) {
          <app-icon class="icon-sm align-self-start" svgIcon="format_quote_fill" />
        }
      </span>

      @if (replyTo.to_msg_text) {
        <span
          [ngClass]="{ 'message-reply-to-text-channel': replyTo.from_another_chat_type === CHAT_SUB_TYPES.CHANNEL }"
          class="text-truncate"
        >
          {{ replyTo.to_msg_text }}
        </span>
      }
      @if (replyTo.to_msg_media?.type && !replyTo.to_msg_text) {
        <span>
          {{ 'attachments.' + $safeNavigationMigration(replyTo.to_msg_media?.type?.toLowerCase()) | translate }}
        </span>
      }
    </div>
  }
</ng-template>

<ng-template #replyToStoryTemplate>
  @if (replyTo?.to_story_id) {
    <div>
      <span
        [innerHTML]="'reply_to_story' | translate: { text: $safeNavigationMigration(replyTo?.to_story_url) } | safeHtml"
      ></span>
      <ng-container
        *ngTemplateOutlet="
          gallery;
          context: {
            gallery_items: [
              {
                url: $safeNavigationMigration(replyTo?.to_story_s3_url),
                type: $safeNavigationMigration(replyTo?.media_type),
                size: $safeNavigationMigration(replyTo?.media_size),
              },
            ],
          }
        "
      >
      </ng-container>
    </div>
  }
</ng-template>

<ng-template #filesTemplate>
  @if (files && files.length) {
    <div class="message-file-content message-margin-head">
      @for (file of files; track $index) {
        @if (file.id || file.url || file.shown_url || file.key) {
          <div
            [cdkContextMenuTriggerFor]="download"
            [cdkContextMenuTriggerData]="{ item: file }"
            class="message-file"
            (click)="onOpenAttachment(file)"
          >
            @if (file.loading) {
              <app-loader color="pi-white" strokeWidth="10" size="smaller" />
            } @else {
              <app-icon class="icon-lg document-icon">draft</app-icon>
              <app-icon class="icon-lg download-icon">{{
                isViewableAttachment(file) ? 'visibility' : 'download'
              }}</app-icon>
            }
            <div class="message-file-info">
              <span class="fw-500 text-truncate">{{ file.name || ('file' | translate) }}</span>
              <span class="message-file-size">{{ file.size | fileSize }}</span>
            </div>
          </div>
        }
      }
    </div>
  }
</ng-template>

<ng-template #audioTemplate>
  @if (audio && audio.length) {
    @for (item of audio; track $index) {
      <div class="message-audio-content">
        @if (!item.shown_url) {
          <div
            class="message-media-action"
            [ngClass]="{ 'click-css': !item.loading }"
            (click)="initMediaShownUrl(item)"
            matTooltip="
               {{ 'attachments.' + attachmentsTooltipMap[item.voice ? 'voice' : item.type] | translate }},
               {{ 'file_size' | translate }}: {{ item.size ? (item.size | fileSize) : '??? B' }},
               {{ 'duration' | translate }}: {{ item.duration }} {{ 'seconds_short' | translate }}
             "
          >
            @if (!item.loading) {
              <app-icon class="icon-md">download</app-icon>
            } @else {
              <app-loader color="pi-white" size="tiny" />
            }
          </div>
        } @else {
          <audio [src]="item.shown_url" controls>
            <source [src]="item.shown_url" [type]="item.mime_type || item.mimeType || 'audio/mpeg'" />
            Your browser does not support the audio tag.
          </audio>
        }
      </div>
    }
  }
</ng-template>

<ng-template #stickerTemplate>
  @if (sticker) {
    <div
      [appPhotoGalleryGroup]="{ clickMode: 'single' }"
      class="message-media-container-wrapper"
      [ngStyle]="{ 'aspect-ratio': (sticker.sizes?.width || 100) / (sticker.sizes?.height || 100) }"
    >
      <div class="message-media-container" [ngStyle]="{ width: (sticker.sizes?.width || 100) + 'px' }">
        @if (!sticker.shown_url || sticker.error) {
          @if (sticker.loading) {
            <app-loader color="pi-white" size="tiny" />
          } @else if (sticker.alt) {
            <span>{{ sticker.alt }}</span>
          }
        }
        @if (sticker.shown_url && !sticker.error) {
          @if (sticker.mime_type?.includes('tgsticker')) {
            <ng-lottie
              [options]="{ animationData: sticker.shown_url }"
              [width]="Math.min(sticker.sizes?.width || 100, 200) + 'px'"
              [height]="Math.min(sticker.sizes?.height || 100, 200) + 'px'"
              class="chat-image"
            />
          } @else if (sticker.video_sticker) {
            <video class="chat-image" [src]="sticker.shown_url" autoplay loop muted playsinline>
              <source [src]="sticker.shown_url" [type]="sticker.mime_type || 'video/webp'" />
              Your browser does not support the video tag.
            </video>
          } @else {
            <img
              class="chat-image click-css"
              [appPhotoGallery]="{ mimeType: sticker.mime_type || 'image/png', url: sticker.shown_url }"
              [src]="sticker.shown_url"
              alt="sticker"
              (error)="loadError(sticker)"
            />
          }
        }
      </div>
    </div>
  }
</ng-template>

<ng-template #logsTemplate>
  @if (logs.length) {
    <div class="message-logs-wrapper">
      <div class="message-logs-toggle-btn click-css" (click)="toggleLogs()">
        {{ isLogsVisible ? ('hide_logs' | translate) : ('show_logs' | translate) }}
      </div>
      @if (isLogsVisible) {
        <div class="message-logs crm-scroll">
          @for (log of logs; track $index) {
            <div class="message-log">
              @if (log.text) {
                <div class="message-logs-text" [matTooltip]="log.text">{{ log.text }}</div>
              } @else {
                <div class="message-logs-text message-logs-no-text">{{ 'message_without_text' | translate }}</div>
              }
              <div class="message-logs-time">{{ 'edited_at' | translate }} {{ log.updated_at | date: 'short' }}</div>
            </div>
          }
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #messageAiTemplate>
  @if (transcription) {
    <div class="mt-1 flex flex-col gap-0.5 border-l-2 border-current/30 pl-2">
      <div class="flex items-center gap-1 text-xs opacity-70">
        <app-icon class="!h-4 !w-4 !text-[16px] !leading-none">transcribe</app-icon>
        <span>{{ 'transcription' | translate }}</span>
      </div>
      @switch (transcription.status) {
        @case (TRANSCRIPTION_STATUS.PENDING) {
          <div class="flex items-center gap-2 text-sm opacity-70">
            <app-loader color="pi-white" size="tiny" />
            <span>{{ 'transcribing' | translate }}</span>
          </div>
        }
        @case (TRANSCRIPTION_STATUS.DONE) {
          <span class="text-sm break-words whitespace-pre-wrap">
            {{ transcription.text || ('transcription_empty' | translate) }}
          </span>
        }
        @case (TRANSCRIPTION_STATUS.FAILED) {
          <div class="flex flex-wrap items-center gap-2 text-sm opacity-70">
            <span>{{ 'transcription_failed' | translate }}</span>
            <button type="button" class="cursor-pointer underline" (click)="onTranscribe(true)">
              {{ 'transcription_retry' | translate }}
            </button>
          </div>
        }
      }
    </div>
  }

  @if (isTranslating) {
    <div class="mt-1 flex items-center gap-2 border-l-2 border-current/30 pl-2 text-sm opacity-70">
      <app-loader color="pi-white" size="tiny" />
      <span>{{ 'translating' | translate }}</span>
    </div>
  } @else if (translation && isTranslationVisible) {
    <div class="mt-1 flex flex-col gap-0.5 border-l-2 border-current/30 pl-2">
      <div class="flex items-center gap-1 text-xs opacity-70">
        <app-icon class="!h-4 !w-4 !text-[16px] !leading-none">translate</app-icon>
        <span>{{ 'translation' | translate }}</span>
      </div>
      <span class="text-sm break-words whitespace-pre-wrap">{{ translation.text }}</span>
    </div>
  }
</ng-template>

<ng-template #textTemplate>
  @if (message.type_message === MESSAGE_TYPES.TEXT && message.text) {
    @if (!markdownChatTypes.includes(chatService.chat.external_type)) {
      <!-- додано #messageTextEl -->
      <span
        #messageTextEl
        [innerHTML]="message.text | highlight: chatService.chatSearchInfo.search_text | linkify | safeHtml"
      >
      </span>
    } @else {
      <div #messageTextEl>
        <markdown [data]="message.text | highlight: chatService.chatSearchInfo.search_text" [inline]="true" />
      </div>
    }
  }
</ng-template>

<ng-template #riaAuctionTemplate>
  @if (riaAuctionMessageTypes.includes(message.type_message)) {
    <div class="d-flex flex-column text-center">
      @if (message.type_message === MESSAGE_TYPES.RIA_AUCTION_ACCEPT) {
        <span class="message-offer-summary">
          <app-icon>handshake</app-icon>
          {{ 'offer_accepted' | translate }}
        </span>
      }
      @if (message.type_message === MESSAGE_TYPES.RIA_AUCTION_DECLINE) {
        <span class="message-offer-summary">
          <app-icon>cancel</app-icon>
          {{ 'offer_rejected' | translate }}
        </span>
      }

      <span>{{ 'offer_an_exchange' | translate }}</span>

      @if (data.price) {
        <span class="fw-bold">{{ data.price }}</span>
      }

      @if (data.comment) {
        <span>{{ data.comment }}</span>
      }

      @if (message.type_message === MESSAGE_TYPES.RIA_AUCTION) {
        <div class="message-btns">
          <app-button (onChangeClick)="onBtnAction(BTN_ACTIONS.RIA_AUCTION_ACCEPT)">
            {{ 'accept' | translate }}
          </app-button>
          <app-button (onChangeClick)="onBtnAction(BTN_ACTIONS.RIA_AUCTION_DECLINE)" [customClass]="'bg-danger'">
            {{ 'reject' | translate }}
          </app-button>
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #riaTradeTemplate>
  @if (riaTradeMessageTypes.includes(message.type_message)) {
    <div class="d-flex flex-column text-center">
      @if (riaTradeAcceptMessageTypes.includes(message.type_message)) {
        <div class="message-offer-summary">
          <app-icon>handshake</app-icon>
          {{ 'offer_accepted' | translate }}
        </div>
      }
      @if (riaTradeDeclineMessageTypes.includes(message.type_message)) {
        <div class="message-offer-summary">
          <app-icon>cancel</app-icon>
          {{ 'offer_rejected' | translate }}
        </div>
      }

      @if (data.photo && riaTradePhotoMessageTypes.includes(message.type_message)) {
        <img class="message-offer-photo" [src]="data.photo" alt="ria photo" />
      }

      @if (data.title) {
        <a href="{{ data.link }}" target="_blank">
          {{ 'offer_a_trade' | translate }} {{ data.title }} ·
          @if (data.price) {
            <strong>{{ data.price }}</strong>
          }
        </a>
      }

      @if (data.term_id === 1) {
        <span>
          {{ 'with_your_surcharge' | translate }} ·
          @if (data.term_price) {
            <strong>{{ data.term_price }}</strong>
          }
        </span>
      }
      @if (data.term_id === 2) {
        <span>
          {{ 'with_my_surcharge' | translate }} ·
          @if (data.term_price) {
            <strong>{{ data.term_price }}</strong>
          }
        </span>
      }

      @if (data.comment) {
        <span>{{ data.comment }}</span>
      }

      @if (message.type_message === MESSAGE_TYPES.RIA_TRADE) {
        <div class="message-btns">
          <app-button (onChangeClick)="onBtnAction(BTN_ACTIONS.RIA_TRADE_ACCEPT)">
            {{ 'accept' | translate }}
          </app-button>
          <app-button (onChangeClick)="onBtnAction(BTN_ACTIONS.RIA_TRADE_DECLINE)" [customClass]="'bg-danger'">
            {{ 'reject' | translate }}
          </app-button>
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #statusTemplate>
  <div class="message-bottom-panel">
    <div class="message-status">
      @if (message.is_ai) {
        <app-icon class="icon-sm" svgIcon="robot" />
      }
      @if (message.is_sent_crm && !message.is_ai) {
        @if (message.created_by_user) {
          <app-avatar
            class="pointer-events-auto"
            size="14px"
            [url]="createdByUserAvatarUrl"
            [title]="createdByUserName"
            [isPhotoGallery]="false"
          />
        }
        <app-icon class="icon-sm pointer-events-auto" [matTooltip]="'sent_from_crm' | translate">people</app-icon>
      }
      @if (message.is_pinned) {
        <app-icon svgIcon="pin" class="icon-sm" />
      }
      @if (message.deleted_at) {
        <span>{{ 'deleted_lower' | translate }}!!</span>
      }
      @if (message.x_data?.last_edit_date && !message.x_data?.edit_hide) {
        <span>{{ 'edited' | translate }}!!</span>
      }
      @if (message.created_at) {
        <span>{{ message.created_at | date: 'HH:mm' }}</span>
      }
      @if (message.status === 'SEND' && message.created_by) {
        @if (message.is_read) {
          <app-icon class="icon-sm">done_all</app-icon>
        } @else {
          <app-icon class="icon-sm">check</app-icon>
        }
      }
      @if (message.status === 'WAIT') {
        <app-icon class="icon-sm">clock_loader_10</app-icon>
      }
      @if (message.status === 'FAIL') {
        <app-icon class="icon-sm text-danger">feedback</app-icon>
      }
    </div>
  </div>
</ng-template>

<ng-template #changeReactionTemplate>
  <div cdkMenu>
    <reactions [chatType]="chatService.chat.external_type" (onChangeReaction)="onChangeReaction($event)" cdkMenuItem>
    </reactions>
  </div>
</ng-template>

<ng-template #showMessageActionsTemplate>
  @if (isShowMessageActionsTemplate()) {
    <div class="action-buttons-container">
      <app-button
        [btnType]="'raised'"
        [customClass]="'rounded-5'"
        [full]="true"
        class="w-100"
        (onChangeClick)="onReplyMessage(SEND_ACTION_TYPE.REPLY_COMMENT)"
      >
        {{ 'reply_comment' | translate }}
      </app-button>

      <app-button
        [btnType]="'raised'"
        [customClass]="'rounded-5'"
        [full]="true"
        class="w-100"
        (onChangeClick)="onReplyMessage(SEND_ACTION_TYPE.SEND_MESSAGE_BY_COMMENT_TO_DIRECT)"
      >
        {{ 'reply_to_direct' | translate }}
      </app-button>
    </div>
  }
</ng-template>

<ng-template #reactionsTemplate>
  @if (reactions?.emojis?.length) {
    <div class="message-reactions-wrapper">
      @for (r of reactions?.emojis; track $index) {
        @if (AVATAR_REACTIONS_EXTERNAL_TYPES.includes(chatService.chat.external_type)) {
          <span class="message-reaction" [class.is-active]="r.my">
            <span class="message-reaction-emoji" [innerHTML]="r.emoji | emoji | safeHtml"></span>

            <span class="avatar-stack">
              @if (r.count <= 3) {
                @for (u of r.users; track $index) {
                  <app-avatar
                    class="rx-avatar"
                    [isPhotoGallery]="false"
                    [chatId]="chatService.chat.id"
                    [mediaId]="u.photo_id"
                    [title]="u.name"
                    [size]="'24px'"
                  />
                }
                @if (missingCount(r) > 0) {
                  <span class="avatar-plus">+{{ missingCount(r) }}</span>
                }
              } @else if (r.count > 3) {
                <span class="message-reaction-count">{{ r.count }}</span>
              }
            </span>
          </span>
        } @else {
          <span class="message-reaction" [class.is-active]="r.my">
            @if (chatService.chat.external_type === CHAT_EXTERNAL_TYPE.TELEGRAM_USER) {
              <span class="message-reaction-emoji" [innerHTML]="r.emoji | emoji | safeHtml"></span>
            } @else {
              <span class="message-reaction-emoji" [innerHTML]="r.emoji"></span>
            }
            @if (r.count >= 2) {
              <span class="message-reaction-count">{{ r.count }}</span>
            }
          </span>
        }
      }
    </div>
  }
</ng-template>
